import React, { useCallback } from "react";
import { deleteBoard } from "../../../../../services/apiBoards";
import { DeleteIcone } from "../../../../../components/UI/Icons";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import { Typography } from "@mui/material";
import { useBoardMutationDialog } from "../../hooks/useBoardMutationDialog";

function Delete({ id }) {
  const deleteBoardDialog = useBoardMutationDialog({
    apiFn: deleteBoard,
    invalidateKeys: ["boards"],
  });

  const submitDeleteBoardDialog = useCallback(() => {
    deleteBoardDialog.submit(id);
  }, [deleteBoardDialog, id]);

  return (
    <>
      <div className="cursor-pointer" onClick={deleteBoardDialog.openDialog}>
        <DeleteIcone height={"24px"} width={"24px"} />
      </div>
      {deleteBoardDialog.isDialogOpen && (
        <FormDialog
          open={deleteBoardDialog.isDialogOpen}
          handleClose={deleteBoardDialog.closeDialog}
          handleSubmit={submitDeleteBoardDialog}
          loading={deleteBoardDialog.isSubmitting}
          buttonTxt={"Delete"}
          title={"Confirmation: Delete Board"}
          alignActions={"center"}
          btnColor="#B71D18"
          cancelBtn={true}
          fullWidth={true}>
          <Typography className="align_text_center mb-2">
            Are you sure to delete this board?
          </Typography>
        </FormDialog>
      )}
    </>
  );
}

export default React.memo(Delete);
